<template>
	<SimpleModalComponent
		heading="Project Status"
		@close-modal="emit( 'close-modal' )"
	>
		<template #content>
			<fieldset class="form__radiogroup mb-24">
				<legend class="invisible">
					Project Status
				</legend>
				<label
					v-for="status in statuses"
					:key="'status-' + status.value"
					:for="status.value"
					class="form__radio"
				>
					<input
						:id="status.value"
						v-model="project_status"
						type="radio"
						name="project-status"
						:value="status.value"
					>
					{{ status.label }}
				</label>
			</fieldset>
		</template>

		<template #buttons>
			<button
				class="button"
				:disabled="loading"
				@click="emit( 'close-modal' )"
			>
				Cancel
			</button>
			<button
				class="button button--fill"
				:class="{ 'button--loading' : loading }"
				:disabled="loading"
				@click="updateProjectStatus"
			>
				Save
			</button>
		</template>
	</SimpleModalComponent>
</template>

<script setup>
import SimpleModalComponent from './SimpleModalComponent.vue';

import { ref, onMounted, defineEmits, defineProps } from 'vue';
import { useDataStore } from '../../stores/data';

const emit = defineEmits( ['status-updated', 'close-modal'] );

const props = defineProps( {
	project: { required: true, type: Object }
} );

const { setProjectStatus } = useDataStore();

const statuses = [
	{ value: 'in_setup', label: 'In-Setup' },
	{ value: 'inactive', label: 'Inactive' },
	{ value: 'on_hold', label: 'On Hold' },
	{ value: 'pending', label: 'Pending' },
	{ value: 'active', label: 'Active' },
	{ value: 'issue', label: 'Issue' },
	{ value: 'at_risk', label: 'At Risk' },
	{ value: 'suspended', label: 'Suspended' },
	{ value: 'terminated', label: 'Terminated' },
	{ value: 'completed', label: 'Completed' },
]
const loading = ref( false );
const project_status = ref( 'active' );
const error_message = ref( null );

const updateProjectStatus = async() => { // eslint-disable-line snakecasejs/snakecasejs
	error_message.value = null;
	loading.value = true;

	if ( !project_status.value ) {
		error_message.value = 'Please select an option';
		loading.value = false;
		return;
	}

	try {
		const response = await setProjectStatus( {
			project_id: props.project.id,
			project_status: project_status.value
		} );
		if ( response && response.data ) {
			emit( 'status-updated' );
		}
	} catch ( error ) {
		error_message.value = error;
		loading.value = false;
	}
};

onMounted( () => {
	project_status.value = props.project.visible_project_status;
} );
</script>